<template>
  <div>
   <el-card>
      <el-alert
    title="企业授权信息"
    type="warning"
    description="请勿随意改动!通讯录应用对应的该企业下的应用id,随意改动会导致系统出错."
    show-icon>
  </el-alert>
   </el-card>
   <el-table :data="catesList" :height="wheight-130" v-loading="loading">
      <el-table-column prop="id" label="ID" ></el-table-column>
      <el-table-column prop="auth_corpid" label="企业id" ></el-table-column>
       <el-table-column prop="title" label="企业名称" ></el-table-column>
       <el-table-column prop="permanent_code" label="授权code" ></el-table-column>
      <el-table-column prop="suite_id" label="第三方应用id" ></el-table-column>
      <el-table-column prop="is_emp" label="调用通讯录" >
        <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.is_emp == '1'" >是</el-tag>
            <el-tag type="info" v-else >否</el-tag>
          </template>
      </el-table-column>
      <el-table-column prop="employee_agent" label="通讯录应用" ></el-table-column>
      <!-- <el-table-column prop="result" label="返回结果" >
        <template slot-scope="scope">
          <el-button type="text" @click="editConfig(scope.row)">编辑</el-button>
        </template>
      </el-table-column> -->
      <el-table-column prop="create_time" label="创建时间" width="150">
        <template slot-scope="scope">
          <span>{{scope.row.create_time | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="update_time" label="更新时间" width="150">
        <template slot-scope="scope">
          <span>{{scope.row.update_time | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
        </template>
      </el-table-column>
    </el-table>
     <div class="content-center content-top-padded">
          <el-pagination
                  background
                  layout="total, sizes, prev, pager, next"
                  @current-change="handleCurrentChange"
                  @size-change="handleSizeChange"
                  :current-page.sync="params.page"
                  :page-sizes="[10,20,50]"
                  :total="total_count"
                  :page-size="params.pageSize">
          </el-pagination>
      </div>
    <el-dialog :title="editTitle" :visible.sync="editVisible"  :before-close="handleEdit">
      <template>
        <el-form ref="form" :model="qyconfigForm" class="demo-ruleForm" label-width="120px">
          <el-form-item label="是否启用">
            <el-input type="number" v-model="qyconfigForm.is_emp" placeholder="0否,1是"></el-input>
          </el-form-item>
          <el-form-item label="通讯录应用">
            <el-input v-model="qyconfigForm.employee_agent" placeholder="通讯录应用"></el-input>
          </el-form-item>
        </el-form>
      </template>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAction" :loading="submitLoading">{{submitLoading ? '提交中' : '保存'}}</el-button>
      </div>
    </el-dialog>
  </div>
</template><script>
  import { mapGetters } from 'vuex'
  import { Message } from 'element-ui'
  import { getPermanent ,editPementConfig} from '../../api/workwx'
  export default {
    data () {
      return {  
        total_count: 0,
        editVisible:false,
        submitLoading:false,
        editTitle: '',
        params: {
          page: 1,
          pageSize: 20
        },
        qyconfigForm: {
          is_emp:'',
          employee_agent:''
        },
        catesList:[],
        loading:false,
        memberTagDialog: false
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      handleCurrentChange (page_num) {
        this.params.page = page_num
        this.getDataList()
      },
      addTemplate () { // 添加商品
        getSnyEmployee({'corp_id':1}).then(res=>{
          this.$message({
            type: 'success',
            message: '同步成功'
          })
        })
      },
      handleSizeChange (pageSize) {
          this.params.page = 1
          this.params.pageSize = pageSize
          this.getDataList()
      },
       submitAction(){
        this.submitLoading = true
        if(this.eidttype=='add'){
          addWorkConfig(this.qyconfigForm).then(res=>{
            if (res.data.data.status) {
              this.$message({
                type: 'success',
                message: '添加成功'
              })
            }
          })
        }else{
          editPementConfig(this.qyconfigForm.id,this.qyconfigForm).then(res=>{
            console.log(this.qyconfigForm.id)
            console.log(this.qyconfigForm)
            if (res.data.data) {
              this.$message({
                type: 'success',
                message: '编辑成功'
              })
              this.getDataList()
              this.editVisible = false
            }
          })
        }
      },
      handleEdit(){
        this.editVisible = false
        this.editTitle = ""
      },
      editConfig(row){
        this.editVisible = true
        if(row){
          this.editTitle = "编辑企业微信"
          this.qyconfigForm.id = row.id
          this.qyconfigForm.is_emp = row.is_emp
          this.qyconfigForm.employee_agent = row.employee_agent
        }
      },
      getDataList () {
        this.loading = true
        console.log(this.params)
        getPermanent(this.params).then(response => {
          console.log(response.data.data.list)
          this.catesList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.deplist = response.data.data.dep
          this.loading = false
        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '获取列表信息出错'
          })
        })
      },
    },
    mounted () {
      this.getDataList()
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 90%;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
    img {
      width: 90%;
    }
  }
  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }
  .service-label .el-checkbox:first-child{
    margin-left: 15px;
  }
  .service-label .el-input:first-child{
    margin-left: 15px;
  }
  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }
  .el-carousel {
    width: 375px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100%!important;
    }
    img {
      width: 100%;
    }
  }
  .grid-attribute {
    table {
      width: 100%!important;
    }
  }
</style>


// WEBPACK FOOTER //
// permanent.vue?076008d8